import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const TagRow=({tag, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{tag.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{tag.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/tag/"+tag.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
 								  
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(tag.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
								  
								  
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={tag.idEstatus==1?'x':'check'} link  size="large" 
                                                color={tag.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(tag.id)} 
                                            />
                                        }
                                        content={tag.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
								  
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default TagRow;